/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Create_ItemInputs */

const en_action_create_item = /** @type {(inputs: Action_Create_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create item`)
};

const de_action_create_item = /** @type {(inputs: Action_Create_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorgang erstellen`)
};

/**
* | output |
* | --- |
* | "Create item" |
*
* @param {Action_Create_ItemInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const action_create_item = /** @type {((inputs?: Action_Create_ItemInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Create_ItemInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_action_create_item(inputs)
	return en_action_create_item(inputs)
});